import React from 'react';

import { useMobile } from '@pkg/hooks';

import './MobileHeader.scss';

interface AuthFlowMobileHeaderProps {
    title: string;
}

export const AuthFlowMobileHeader = ({ title }: AuthFlowMobileHeaderProps) => {
    const { isMobile } = useMobile();

    if (!isMobile) {
        return null;
    }

    return <nav className="auth-flow-mobile-header">{title}</nav>;
};
